import * as a from "react";
import t from "../lib/IconBase.es.js";
import i from "../defs/MedalMilitary.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(t, { ref: r, ...o, weights: i }));
e.displayName = "MedalMilitaryIcon";
const c = e;
export {
  c as MedalMilitary,
  e as MedalMilitaryIcon
};
